import {User} from '@nh/angular-tses';

/**
 * Utility function that returns an array of users sorted alphabetically according to their username.
 * This does not mutate the original array.
 *
 * @param users {User[]} the array of users to be sorted
 */
export function sortUsers(users: User[]): User[] {
  return users
    ? users.concat().sort((user1: User, user2: User) => {
        return user1.userName <= user2.userName ? -1 : 1;
      })
    : [];
}
